import styled from 'styled-components';

export const VaultCardWrapper = styled.div`
  width: 100%;
  margin: 16px;
  margin-bottom: 32px;
  background-color: rgba(24, 24, 24, 1);
  border-radius: 8px;

  .header-container {
    padding: 16px;
    padding-bottom: 4px;
    border-bottom: 1px solid #262b48;
    &.fold {
      border: none;
    }
    background-color: rgba(24, 24, 24, 1);
    border-radius: 8px;
  }

  .header {
    display: flex;
    flex-wrap: wrap;
    .content {
      display: flex;
      align-items: center;
    }
    svg {
      margin-right: 4px;
    }
  }

  .col-item {
    margin-bottom: 12px;

    &:not(:last-child) {
      padding-right: 12px;
    }
  }

  @media (max-width: 992px) {
    .col-item:last-child {
      margin-bottom: 8px;
    }

    .top-info {
      padding: 5px;
    }
    .bottom-info {
      padding: 5px;
      text-align : center !important;
    }
  }

  .title {
    font-size: 14px;
    line-height: 16px;
    color: #a1a1a1;
    margin-bottom: 4px;
  }

  .top-info {
    padding: 12px;
    margin-bottom: 0px !important;
  }

  .bottom-info {
    padding: 18px;
    justify-content : center;
    text-align : center !important;
    margin-bottom: 10px !important;
  }

  .content {
    color: #fff;
    font-size: 14px;
    line-height: 16px;

    img {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
    svg {
      width: 16px;
      height: 16px;
      margin-right: 4px;
    }
  }
  .expand-icon-wrapper {
    text-align: center;
    cursor: pointer;
  }

  .expand-icon {
    width: 12px;
    height: 12px;
    margin-top: 12px;
  }

  @media (max-width: 992px) {
    .expand-icon {
      margin-top: 0;
    }
  }
`;

export const CardItemWrapper = styled.div`
  .card-title {
    display: flex;
    margin-bottom: 12px;
    justify-content: space-between;
    align-items: center;
    .icon {
      color: #aaa;
      cursor: pointer;
      &:hover {
        color: #fff;
      }
    }
  }

  .card-item {
    position: relative;
    background-color: rgba(24, 24, 24, 1);
    border-radius: 8px;
    margin-bottom: 16px;
    padding: 16px;
    min-height: 165px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    border-bottom: 1px solid #262b48;

    @media only screen and (min-width: 992px) {
      border-radius: unset;
      border-right: 1px solid #262b48;
      border-bottom: unset;
    }
  }

  .button {
    width: 100%;
    color: #fff;
    border-radius: 8px;
    border: none;
    box-sizing: border-box;
    font-size: 14px;
    line-height: 36px;
    background-color: rgba(199, 99, 247, 1);
    text-align: center;
    cursor: pointer;
  }

  button:disabled {
    background: rgba(99, 99, 99, 1);
    cursor: not-allowed;
  }

  .input-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
    input {
      width: 80%;
      height: 31px;
      border: none;
      font-size: 24px;
      line-height: 31px;
      background: transparent;
      &:focus {
        outline: none;
      }
    }
    .max {
      font-size: 14px;
      line-height: 16px;
      color: #fff;
      background-color: rgba(19, 141, 243, 1);
      padding: 8px 15px;
      border-radius: 5px;
    }
  }

  .center-amount {
    text-align: center;
    margin-top: 24px;
  }
`;
